import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "banner-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _directive_clean_html = _resolveDirective("clean-html")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Banner, {
      label: _ctx.t('authConfig.stateBanner.disabled', _ctx.tArgs),
      color: "warning",
      "data-testid": "auth-provider-disabled-warning-banner"
    }, null, 8, ["label"]),
    _cache[1] || (_cache[1] = _createTextVNode()),
    (_ctx.disableLocalAuth)
      ? (_openBlock(), _createBlock(_component_Banner, {
          key: 0,
          color: "warning",
          "data-testid": "auth-provider-disable-local-auth-banner"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("span", null, null, 512), [
              [_directive_clean_html, _ctx.t('authConfig.bannerEnableAuthProvider', {}, true)]
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createVNode(_component_Banner, {
      color: "warning",
      "data-testid": "auth-provider-admin-permissions-warning-banner"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _withDirectives(_createElementVNode("span", null, null, 512), [
            [_directive_clean_html, _ctx.t('authConfig.associatedWarning', _ctx.tArgs, true)]
          ]),
          _cache[0] || (_cache[0] = _createTextVNode()),
          _renderSlot(_ctx.$slots, "additional-warning", {}, undefined, true)
        ])
      ]),
      _: 3
    })
  ]))
}